// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

export const GET_RESOURCES_DATA =
  "cnquery.explorer.ResourcesExplorer.GetResourcesData";
